/* De bundelregel in het Also add-blok.

   De korting zelf staat in Shopify als twee automatische kortingen op aantal
   artikelen (2 stuks = 10%, 3 stuks = 15%). Deze regel rekent niets af, hij
   vertelt alleen wat er gaat gebeuren. Zou hij zelf gaan rekenen, dan ontstaat
   er een tweede waarheid die bij de eerste prijswijziging uit de pas loopt met
   de checkout. De drempels staan als data-attribuut in de HTML en moeten gelijk
   blijven aan de kortingen in Shopify.

   ALLE DREMPELS DIE NOG TE HALEN ZIJN WORDEN GENOEMD, NIET ALLEEN DE EERSTE.
   Bij één artikel in de winkelwagen:
     Add 1 more and save 10%, or 2 more and save 15%
   Bij twee:
     Add 1 more and save 15%
   Eerder stond er alleen de eerstvolgende drempel, en dan lijkt 10% het hele
   aanbod - terwijl er een tweede trede achter zit die het interessanter maakt.

   ER WORDT GETELD VANAF WAT ER ÉCHT IN DE WINKELWAGEN LIGT.
   Het product op deze pagina telde eerst alvast mee, alsof het al besteld was.
   Dat maakte de getallen onvoorspelbaar: met één artikel in de wagen stond er
   "Add 1 more and save 15%", want intern stond de teller al op twee. Nu komt het
   getal overeen met wat de klant in zijn winkelwagen ziet.

   BIJ EEN LEGE WINKELWAGEN BLIJFT DE VASTE REGEL STAAN, die beide drempels
   noemt. Wie net binnenkomt moet eerst wéten dat er een staffel is.

   Er wordt niets ververst zonder aanleiding: bij het laden, na een toevoeging
   vanuit dit blok, en bij het cart:update-event dat de rest van het thema ook
   gebruikt. */
(function () {
  'use strict';
  if (window.__bundleMeterReady) return;
  window.__bundleMeterReady = true;

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function tiers(node) {
    var raw = node.getAttribute('data-tiers') || '';
    return raw.split(';').map(function (part) {
      var bits = part.split('|');
      return { items: parseInt(bits[0], 10), percent: parseInt(bits[1], 10) };
    }).filter(function (tier) {
      return tier.items > 0 && tier.percent > 0;
    }).sort(function (a, b) { return a.items - b.items; });
  }

  function fill(node, attribute, values) {
    var text = node.getAttribute(attribute) || '';
    Object.keys(values).forEach(function (key) {
      text = text.split('{' + key + '}').join(values[key]);
    });
    return text;
  }

  function render(node, count) {
    var steps = tiers(node);
    if (!steps.length) return;

    var message = node.querySelector('[data-bundle-message]');
    if (!message) return;

    var todo = steps.filter(function (tier) { return count < tier.items; });

    if (todo.length) {
      var parts = todo.map(function (tier, index) {
        return fill(node, index === 0 ? 'data-next-text' : 'data-more-text', {
          count: tier.items - count,
          percent: tier.percent
        });
      });
      message.textContent = parts.join(', ');
    } else {
      var top = steps[steps.length - 1];
      message.textContent = fill(node, 'data-max-text', { percent: top.percent });
    }

    node.classList.toggle('bundle-meter--earned', todo.length < steps.length);
  }

  function refresh() {
    var nodes = document.querySelectorAll('[data-bundle-meter]');
    if (!nodes.length) return;

    fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        var count = cart && typeof cart.item_count === 'number' ? cart.item_count : 0;

        /* Lege winkelwagen: laat de vaste regel staan die al in de HTML stond. */
        if (count < 1) return;

        nodes.forEach(function (node) { render(node, count); });
      })
      .catch(function () {
        /* Kan de winkelwagen niet gelezen worden, dan is de vaste regel het
           veiligste wat er kan staan. */
      });
  }

  document.addEventListener('cart:update', refresh);
  document.addEventListener('shopify:section:load', refresh);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh);
  } else {
    refresh();
  }
})();
